import { z } from 'zod';
import { linkSchema, mediaFileSchema, strapiEntitySchema } from './common.js';

export const strapiProfileSchema = strapiEntitySchema.extend({
  name: z.string(),
  slug: z.string(),
  headline: z.string().nullish(),
  summary: z.string().nullish(),
  shortBio: z.string().nullish(),
  avatar: mediaFileSchema.nullish(),
  coverImage: mediaFileSchema.nullish(),
  location: z.string().nullish(),
  timezone: z.string().nullish(),
  website: z.string().nullish(),
  dateOfBirth: z.string().nullish(),
  languages: z.unknown(),
  interests: z.unknown(),
  email: z.string(),
  phone: z.string().nullish(),
  socialLinks: z.array(linkSchema).nullish(),
  resume: mediaFileSchema.nullish(),
});

export type StrapiProfileResponse = z.infer<typeof strapiProfileSchema>;
